import React from 'react'
import InstagramIcon from '@mui/icons-material/Instagram';
import MailIcon from '@mui/icons-material/Mail';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { blue } from '@mui/material/colors';
import * as scroll from 'react-scroll'
import {Link} from 'react-dom'

function Footer() {
  return (
<div id='Contact' className='w-[95%] mx-auto mt-12'>  
  <div className="relative w-full h-[320px] bg-[#D5FF3C] border border-gray-300 rounded-3xl shadow-lg">  
    <div className="absolute right-2 bottom-2 w-full h-full bg-gradient-to-r from-[#1501FF] to-[#AC7EFF] border border-[#D5FF3C] rounded-3xl shadow-lg">
      <div className='flex flex-wrap'>
        <div className='w-full flex justify-center md:justify-start md:w-1/2'>
        <ul className='px-10 py-5 uppercase font-bold text-[#D5FF3C] *:mt-6 text-2xl'>
          <li><a target='_blank' href="jodakianm@gmail.com">email<MailIcon sx={{fontSize:25}}/></a></li>
          <li><a target='_blank' href="https://www.linkedin.com/in/mohammad-jodakian">linkedin<LinkedInIcon sx={{fontSize:25}}/></a></li>
          <li><a target='_blank' href="https://github.com/mohammadjodaki">github<GitHubIcon sx={{fontSize:25}}/></a></li>
          <li><a target='_blank' href="https://www.instagram.com/mohammad_jodaki_web/">instagram<InstagramIcon sx={{fontSize:25}}/></a></li>
        </ul>
        </div>
        <div className='w-full md:w-1/2 hidden md:flex justify-center items-center'>
        <scroll.Link
      to='Menu'
      smooth={true}
      duration={1500}
      >        <div className='w-36 h-36 bg-[#D5FF3C] rounded-full cursor-pointer'>
      <ArrowUpwardIcon sx={{fontSize:144, color:blue }}/>
        </div></scroll.Link>
        </div>
      </div>
      <div className='flex justify-center mx-5 border-t-2 border-[#D5FF3C]'>
        <h2 className='mt-3 font-bold text-[#D5FF3C]'>2024 - © Mohammad Jodaki</h2>
        </div>  
    </div>  
  </div>  
</div>
  )
}

export default Footer